/** @jsx jsx */

import { Colors, Grid, Icon, Text } from '@zapier/design-system';
import { jsx } from '@emotion/core';

import Dismiss from 'app/developer-v3/components/Dismiss';
import Link from 'app/common/components/Link';

import Styles from '../CTAVersioning.styles';

type Props = {
  onDismiss: () => void;
  version: string;
};

function PromotionDone(props: Props) {
  const { onDismiss, version } = props;

  return (
    <div css={Styles.root(Colors.StatusSuccessWeakest)}>
      <Grid columns="30px auto 20px" gap={20}>
        <Icon color="StatusSuccess" name="formCheckCircle" size={30} />
        <div>
          <Text fontWeight={600} tag="h2" type="Body4">
            Version {version} is promoted!
          </Text>
          <Text margin="10px 0px 0px" tag="p">
            Your integration version has been successfully promoted. You can
            migrate users to this version now. If you notice any issues,{' '}
            <Link href="https://developer.zapier.com/contact" target="_blank">
              contact us
            </Link>
            .
          </Text>
        </div>
        <Dismiss onDismiss={onDismiss} />
      </Grid>
    </div>
  );
}

export default PromotionDone;
